const EARTH_RADIUS_METERS = 6378137

export type Point = {
  latitude: number
  longitude: number
}

export function distanceMeters(from: Point, to: Point): number {
  const lat1 = (from.latitude * Math.PI) / 180
  const lat2 = (to.latitude * Math.PI) / 180
  const dLat = ((to.latitude - from.latitude) * Math.PI) / 180
  const dLng = ((to.longitude - from.longitude) * Math.PI) / 180

  const h =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2)

  return 2 * EARTH_RADIUS_METERS * Math.asin(Math.sqrt(h))
}

export function pointAtDistance(
  origin: Point,
  meters: number,
  bearingDegrees: number
): Point {
  const angularDistance = meters / EARTH_RADIUS_METERS
  const bearing = (bearingDegrees * Math.PI) / 180
  const lat1 = (origin.latitude * Math.PI) / 180
  const lng1 = (origin.longitude * Math.PI) / 180

  const lat2 = Math.asin(
    Math.sin(lat1) * Math.cos(angularDistance) +
      Math.cos(lat1) * Math.sin(angularDistance) * Math.cos(bearing)
  )

  const lng2 =
    lng1 +
    Math.atan2(
      Math.sin(bearing) * Math.sin(angularDistance) * Math.cos(lat1),
      Math.cos(angularDistance) - Math.sin(lat1) * Math.sin(lat2)
    )

  return {
    latitude: (lat2 * 180) / Math.PI,
    longitude: (lng2 * 180) / Math.PI,
  }
}
